/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Password_DigitInputs */

const nl_validation_password_digit = /** @type {(inputs: Validation_Password_DigitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wachtwoord moet minimaal één cijfer bevatten`)
};

/**

* @param {Validation_Password_DigitInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const validation_password_digit = /** @type {((inputs?: Validation_Password_DigitInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Password_DigitInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_validation_password_digit(inputs)
});
export { validation_password_digit as "validation.password.digit" }